<section>

    <div class="sec" style="margin-top: 0;">
        <h2>Arbeitsschritt</h2>
        <div class="filter-bttn" (click)="openWorkSteps($event)">
            <span class="overflow-bullets">
                Nr.{{ticketSrv.activeWorkstep?.number}} <span *ngIf="ticketSrv.activeWorkstep?.description">/ {{ticketSrv.activeWorkstep?.description}}</span> / {{ticketSrv.activeWorkstep?.contactDescription}} / {{ticketSrv.activeWorkstep?.employee?.firstName}} {{ticketSrv.activeWorkstep?.employee?.lastName}}
            </span>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" class="svg-inline--fa fa-sort-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
          </div>
    </div>

    

    <div class="sec">
        <h2>Status</h2>
        <div id="status-view" [ngStyle]="{'background': ticketSrv.selectedTicket.state | TicketStateColor : ticketSrv.selectedTicket.isClosed : '0.15'}">
            <div [ngStyle]="{'background': ticketSrv.selectedTicket.state | TicketStateColor : ticketSrv.selectedTicket.isClosed}"></div>
            <h3 [ngStyle]="{'color': ticketSrv.selectedTicket.state | TicketStateColor : ticketSrv.selectedTicket.isClosed}">{{ticketSrv.selectedTicket.state | TicketStateDescription: ticketSrv.selectedTicket.isClosed}}</h3>
        </div>
    </div>
    <div class="sec">
        <h2>Zeit</h2>
        <div class="time">
            <table>
                <tr *ngIf="ticketSrv.targetTime > 0">
                    <td>Soll:</td>
                    <td>{{ticketSrv.targetTimeString}}</td>
                </tr>
                <tr>
                    <td>Ist:</td>
                    <td [ngStyle]="{'color': ticketSrv.timeDifferenceInPercent > 100 ? 'var(--red)' : ' var(--green)'}"> {{ ticketSrv.isTimeString}} Std.</td>
                </tr>
                <tr *ngIf="ticketSrv.timeDifferenceInPercent > 100">
                    <td></td>
                    <td><span style="font-weight: 300; font-size: 12px; color: var(--red)">(+{{this.ticketSrv.timeDifferenceAsString}} Std.)</span></td>
                </tr>
            </table>
            <div style="position: relative;" *ngIf="ticketSrv.targetTime > 0">
                <div class="timeline" style="background: rgba(var(--greenRGB), 0.2); width: 100%; position: absolute;" >
                    <div class="timeline" style="background: var(--green)" [ngStyle]="{'width.%': ticketSrv.timeDifferenceInPercent, 'background': ticketSrv.timeDifferenceInPercent > 100 ? 'var(--red)' : 'var(--green'}"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="sec" style="position: relative;">
        <h2>Fortschritt</h2>
        <h5>{{ticketSrv?.process}}%</h5>
        <div style="position: relative;">
            <div class="timeline" style="background: rgba(var(--blueRGB), 0.2); width: 100%; position: absolute;" >
                <div class="timeline" style="background: var(--blue)" [ngStyle]="{'width.%': ticketSrv?.process > 4 ? ticketSrv?.process : 4}"></div>
            </div>
            
        </div>

    </div>
    <div class="sec">
        <h2>Bearbeiter</h2>
        <div id="editors">
            <div  *ngFor="let editor of ticketSrv?.employees; let i = index">
                <div [ngStyle]="{'zIndex': i * -1}" class="user-circle">{{editor.firstName.charAt(0).toUpperCase()}}{{editor.lastName.charAt(0).toUpperCase()}}</div>
                <div class="editor-name">{{editor.firstName}} {{editor.lastName}}</div>
            </div>
        </div>
    </div>
    <div class="sec">
        <app-ticket-detail-assets [canDelete]="false"></app-ticket-detail-assets>
    </div>
</section>